import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-youtube',
  templateUrl: 'youtube.html'
})
export class YoutubePage {

  client: any;
  event: any;
  dataSocial: any;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.dataSocial = this.params.get('social');
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-social/youtube/youtube.ts